import { MultiSelect } from '@mantine/core';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RobotTag } from '@mygpt/types/tag';

export interface TagFilterProps {
  tags: RobotTag[];
  selectedTagIds: string[];
  onTagChange: (tagIds: string[]) => void;
  loading?: boolean;
  width?: number;
}

const TagFilter = memo(({ tags, selectedTagIds, onTagChange, loading = false, width = 280 }: TagFilterProps) => {
  const { t } = useTranslation();

  const selectData = useMemo(() => tags.map((tag) => ({ value: tag.id, label: tag.name })), [tags]);

  return (
    <MultiSelect
      data={selectData}
      value={selectedTagIds}
      onChange={onTagChange}
      placeholder={t('tag.filter_placeholder', 'Filter by tags...')}
      searchable
      clearable
      nothingFoundMessage={t('tag.no_tags_found', 'No tags found')}
      maxDropdownHeight={240}
      disabled={loading}
      style={{ width }}
    />
  );
});

TagFilter.displayName = 'TagFilter';

export default TagFilter;
